import React from 'react'
import {Request} from "kaiju.core";
import {App} from "antd"
import i18n from "i18next";

export const useStore = ({collectionId}: any) => {
    const [data, setData] = React.useState<any[]>([])
    const [roles, setRoles] = React.useState<any[]>([])
    const [columns, setColumns] = React.useState<any[]>([])
    const permissions: { [p: string]: any } = {}
    const [activeRoles, setActiveRoles] = React.useState<{ [p: string]: string }>({})
    const {notification} = App.useApp()

    const handleSetData = (d: any[]) => {
        const rActive: { [p: string]: string } = {}
        d.forEach((el: any) => {
            rActive[el.role_id] = el.role
        })
        setActiveRoles({...activeRoles, ...rActive})
        setData(d)
    }

    const loadData = async (collectionId: any) => {
        const {result} = await Request("ContentTypeBuilder.media.permissions.list", {collection: collectionId})
        setColumns(result.columns)
        handleSetData(result.data)
    }

    const loadRoles = async () => {
        const resp = await Request("Role.list", {})
        setRoles(resp.result)
    }

    const setPermission = (role: string, permission: string, value: boolean) => {
        if (!Object.keys(permissions).includes(role)) {
            permissions[role] = {}
        }
        permissions[role][permission] = value
    }

    const loadAll = async (collectionId: string) => {
        await loadData(collectionId)
        await loadRoles()
    }

    const addRole = (roleId: string) => {
        const newRow: any[] = []

        roles.forEach((el: any) => {
            if (el.value === roleId) {
                newRow.push({
                    role: el.label,
                    role_id: el.value,
                })
            }
        })
        if (!Object.keys(permissions).includes(roleId)) {
            permissions[roleId] = {}
        }

        handleSetData([...data, ...newRow])
    }

    const getRoles = () => {
        return roles.filter((el: any) => (!Object.keys(activeRoles).includes(el.value)))
    }

    const save = () => {
        Request("ContentTypeBuilder.medialibrary.permissions.set", {collection: collectionId, permissions: permissions}).then(() => {
            notification.success({
                duration: 2,
                message: i18n.t("common.saved"),
            });
        })

    }

    React.useEffect(() => {
        loadAll(collectionId).then()
    }, [collectionId])

    return {
        data,
        getRoles,
        columns,
        roles,
        addRole,
        setPermission,
        save,
    }
}